import DragonsQuillLogo from "../../assets/ProjectLogos/DragonsQuill-Logo.svg";
import FactionGeneratorLogo from "../../assets/ProjectLogos/FactionGenerator-Logo.svg";
import HitpointCalculatorLogo from "../../assets/ProjectLogos/HitpointCalculator-Logo.svg";

const initialState = {
  projectsMetaData: [
    {
      id: "dq",
      name: "Dragon's Quill",
      tagline: "Helps people write structured RPG adventures",
      imageSrc: "/ProjectsImages/DragonsQuill/DragonsQuill-playingPhoto.jpg",
      imageAlt: "Koen playing dungeons and dragons",
      logoSrc: DragonsQuillLogo,
      logoAlt: "Dragon's Quill logo"
    },
    {
      id: "fg",
      name: "Faction Generator",
      tagline: "Generates new factions to add to your fantasy world",
      imageSrc: "/ProjectsImages/Factiongenerator/Factiongenerator-laptop.jpg",
      imageAlt:
        "Laptop with the faction generator app open on top of the map of Waterdeep",
      logoSrc: FactionGeneratorLogo,
      altSrc: "Faction Generator logo"
    },
    {
      id: "hc",
      name: "Hitpoint Calculator",
      tagline:
        "Helps people who suck at math to track hitpoints in D&D battles",
      imageSrc:
        "/ProjectsImages/HitpointCalculator/HitpointCalculator-minis.jpg",
      imageAlt:
        "Phone with mockup of hitpoint calculator app open in between of d and d miniatures",
      logoSrc: HitpointCalculatorLogo,
      altSrc: "Hitpoint Calculator logo"
    }
  ],
  pages: [
    {
      id: "p-about",
      name: "About me",
      tagline: "Designer, Developer & Dungeon Master"
    }
  ]
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
export default reducer;
